const PaymentSuccess = () => {
  return (
    <>
      <div>Success message</div>
    </>
  );
};

export default PaymentSuccess;
